<script>
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";
import IconPhone from "@js/components/Icons/IconPhone.vue";

export default {
    name: "CallbackButton",
    components: {IconPhone},
    props: {
        btnText: {
            type: String,
            default: 'Заказать звонок'
        },
        classes: {
            type: String,
            default: '',
        }
    },
    setup() {
        const callbackStore = useCallbackFormsStore()

        return {callbackStore}
    }
}
</script>

<template>
    <button type="button" @click.prevent="callbackStore.showCallbackPopup"
            :class="[
                'group inline-flex justify-center items-center  text-white hover:text-indigo-600 border-2 border-indigo-600 bg-indigo-600 hover:bg-transparent font-medium rounded-full text-sm px-5 py-2.5 focus:outline-none transition',
                classes,
            ]">
        <IconPhone class="w-6 h-6 me-2 text-white group-hover:text-indigo-600 transition"/>
        <span class="text-base">
            {{ btnText }}
        </span>
    </button>
</template>

<style scoped lang="scss">

</style>
